import { newSensorConectionObservable } from "../commonRequests";
import { AppConfgiStore, CustomerStore, DefAppConfig, DEV_group, DEV_mes, EnvHwStore, genNewGroup, GroupStore, MesurmentStore } from "../probeStore";
import { addOrReplaceOrder, AppSetings, EnvHw, Orders, TanixUsers } from "./authDataAgregation";
import * as auRequests from "../au_commonRequest";
import { parseTempretureMsg, registerTempretureActiveChannal } from "../sub/sensorTepretureParser";
import { UserCredential } from "../store";
import { parseEnvHwListToMap, parseExportDataToEntry } from "../sub/dataParser";
import { MES_KEY_STAGE } from "../enum";
export function pushNewGroup(mesurmentList, groupName) {
    const newGroup = genNewGroup(mesurmentList, groupName);
    GroupStore.add(newGroup, newGroup.uid);
}
export async function pushNewOrder(mes) {
    const resData = await auRequests.addNewOrder(mes);
    if (!resData || !resData.newObj) {
        console.warn('no or wrong formated mesage when adding MES');
        return;
    }
    const data = await addOrReplaceOrder(resData.newObj);
    return data.newObj;
}
export async function pushNewEnviroment(env) {
    const resData = await auRequests.setEnvMeasurement(env);
    if (!resData || !resData.newObj) {
        console.warn('no or wrong formated mesage when adding ENV');
        return;
    }
    const data = await addOrReplaceOrder(resData.newObj);
    return data.newObj;
}
export async function pushOrderValidation(mes) {
    const resData = await auRequests.validateNewOrder(mes.dbUid);
    if (!resData || !resData.newObj) {
        console.warn('no or wrong formated mesage when adding ORDER VALIDATE');
        return;
    }
    const data = await addOrReplaceOrder(resData.newObj);
    return data.newObj;
}
export async function pushOrderExport(mes) {
    const resData = await auRequests.exportOrder(mes.dbUid);
    if (!resData || !resData.newObj) {
        console.warn('no or wrong formated mesage when adding ORDER VALIDATE');
        return;
    }
    const data = await addOrReplaceOrder(resData.newObj);
    const ret = await parseExportDataToEntry(resData.meta, data.newObj);
    return ret;
}
export async function pushNewDataPoint(dataPoint) {
    const resData = await auRequests.addNewDataPoint(dataPoint);
    if (!resData || !resData.newObj) {
        console.warn('no or wrong formated mesage when adding DATA POINT');
        return;
    }
    const data = await addOrReplaceOrder(resData.newObj);
    return data.newObj;
}
/* ====== SOCKET ====== */
export function registerTempretureLisener(id, run) {
    return registerTempretureActiveChannal(id, run);
}
export function registerNewSensorConectionLisener(run) {
    return newSensorConectionObservable.subscribe(run);
}
/* ====== INIT ====== */
export async function reloadOrders() {
    Orders.clear();
    Orders.initLoader();
    const orderList = await Orders.getAll();
    MesurmentStore.clear();
    MesurmentStore.addAll(orderList, orderList.map(mes => mes.uid));
    /*  Orders.getAll().then(data => {
        MesurmentStore.addAll(data, data.map(mes => mes.uid));
    }) */
}
export async function reloadGlobalData() {
    TanixUsers.clear();
    EnvHw.clear();
    AppSetings.clear();
    TanixUsers.initLoader();
    EnvHw.initLoader();
    AppSetings.initLoader();
    await Promise.all([reloadOrders(), TanixUsers.getAll().then(data => {
            CustomerStore.set(data);
        }), , AppSetings.getAll().then(data => {
            if (data) {
                AppConfgiStore.set(data);
            }
        }), EnvHw.getAll().then(data => {
            const envHwMap = parseEnvHwListToMap(data);
            Object.keys(envHwMap).forEach(key => {
                EnvHwStore.set(key, envHwMap[key]);
            });
        })]);
    // groupMock();
    // initMock()
}
UserCredential.subscribe(val => {
    if (val) {
        reloadGlobalData();
    }
});
/* ====== MOCK ====== */
// loginUser('dev', 'xxx');
// initMockProbeData();
async function groupMock() {
    const orderList = await Orders.getAll();
    const validTarget = await orderList.find(val => val.dinamic.stage.key === MES_KEY_STAGE.beforeMes);
    if (validTarget) {
        const newGroup = genNewGroup([validTarget], 'DEV 0');
        GroupStore.add(newGroup, newGroup.uid);
    }
}
async function initMock() {
    setTimeout(async () => {
        await TanixUsers.getAll();
        await Orders.getAll();
        // TanixUsers.DEV_directSet(DEV_customers);
        Orders.DEV_directSet(DEV_mes);
        // CustomerStore.set(DEV_customers);
        MesurmentStore.addAll(DEV_mes, DEV_mes.map(val => val.uid));
        GroupStore.addAll(DEV_group, DEV_group.map(val => val.uid));
        AppConfgiStore.set(DefAppConfig);
        console.log('MOCK DATA SET');
    }, 1); // TODO , race condition
}
function initMockProbeData() {
    let lastVal = 0;
    setInterval(() => {
        const x = new Date().getTime();
        lastVal = +Math.round(Math.random() * 2000) / 1000 - 1;
        parseTempretureMsg({
            sensorID: "10101010101010101010",
            value: lastVal,
            timeStamp: x
        });
    }, 1000);
    let lastVal2 = 0;
    setInterval(() => {
        const x = new Date().getTime();
        lastVal2 = +Math.round(Math.random() * 2000) / 1000 - 1;
        parseTempretureMsg({
            sensorID: "30303030303030303030",
            value: lastVal2,
            timeStamp: x
        });
    }, 1000);
}
/* const DEV_token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IiJ9.eyJpZCI6Nywicm9sZSI6MSwibmFtZSI6ImRldiIsImlhdCI6MTY0MjE0MjE4NCwiZXhwIjoxNjQyMTQ1Nzg0fQ.7RzfZPdBZny_mA09crlK5YS21LxIgnfu-ke9vfgCi9U";
UserCredential.connect({
    userName: 'dev',
    id: 0,
    role: 0,
    roleInfo: USER_ROLE.DEV
},
    DEV_token); */
window.DEV_pullProbeId = (newId) => {
    const usedId = (newId) ? newId : Math.floor(Math.random() * 9).toString().padStart(2, '0').repeat(2);
    newSensorConectionObservable.set({
        sensorID: usedId
    });
};
